import { render, staticRenderFns } from "./GCC.vue?vue&type=template&id=04a3388e&"
import script from "./GCC.vue?vue&type=script&lang=js&"
export * from "./GCC.vue?vue&type=script&lang=js&"
import style0 from "./GCC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports